import React from "react";
import { VintomError } from "src/api/model/error/VintomError";
import { I18n } from "../../../../i18n/i18n";
import { ScenarioElementPlaybackState } from "../../../../uiModel/playback/ScenarioElementPlaybackState";
import { LoaderIconComponent } from "../../../icons/loader/LoaderIconComponent";
import { PlayIconComponent } from "../../../icons/playback/PlayIconComponent";
import { ReplayIconComponent } from "../../../icons/playback/ReplayIconComponent";
import { VolumeMutedIconComponent } from "../../../icons/volume/VolumeMutedIconComponent";
import { MessageComponent } from "../common/MessageComponent";

import { LoadingPageComponent } from "../common/LoadingPageComponent";

import "@styles/c-desktopOverlay.scss";

interface Props {
  // configuration: PlayerControls;
  i18n: I18n;
  isCTADisplayed: boolean;
  isPlayPauseEnabled: boolean;
  playbackState: ScenarioElementPlaybackState;
  isLoading: boolean;
  isVolumeMuted: boolean;
  onPlay: () => void;
  onReplay: () => void;
  onUnMute: () => void;
  loadingPageVisible: boolean;
  message?: string | VintomError;
  onSendError: (error: VintomError) => void;
  playIconOnPoster: boolean;
  disableIcon: boolean;
}

export const DesktopOverlayComponent: React.SFC<Props> = (props) => {
  const {
    i18n,
    isCTADisplayed,
    isPlayPauseEnabled,
    playbackState,
    isLoading,
    isVolumeMuted,
    onPlay,
    onReplay,
    onUnMute,
    loadingPageVisible,
    message,
    onSendError,
    playIconOnPoster,
    disableIcon
  } = props;

  const isControlDisplayed = !!message ||
    isLoading ||
    isVolumeMuted ||
    isPlayPauseEnabled && ["paused", "scenarioFinished"].indexOf(playbackState) > -1 && !isCTADisplayed;

  if (!isControlDisplayed) {
    return <></>;
  }

  if (loadingPageVisible) {
    return(<LoadingPageComponent
      i18n={i18n}/>);
  }

  if (message) {
    return (
      <MessageComponent
        i18n={i18n}
        message={message}
        onSendError={onSendError}
      />
    );
  }

  let isDisabled: boolean;
  let icon: React.ReactNode;
  let onClickCallback: () => void;

  if (isLoading) {
    isDisabled = true;
    icon = <LoaderIconComponent />;
    onClickCallback = () => {};
  } else if (playIconOnPoster === true && disableIcon) {
    return <></>;
  } else if (playbackState === "paused") {
    isDisabled = false;
    icon = <PlayIconComponent />;
    onClickCallback = onPlay;
  } else if (playbackState === "scenarioFinished") {
    isDisabled = false;
    icon = <ReplayIconComponent />;
    onClickCallback = onReplay;
  } else {
    isDisabled = false;
    icon = <VolumeMutedIconComponent />;
    onClickCallback = onUnMute;
  }

  return (
    <button
    className="c-desktopOverlay"
    disabled={isDisabled}
    onClick={(event) => {
      onClickCallback();
    }}
  >
    {icon}
  </button>
  );
};
